import { render, staticRenderFns } from "./Courses.vue?vue&type=template&id=52b0b5ba&scoped=true"
import script from "./Courses.vue?vue&type=script&lang=js"
export * from "./Courses.vue?vue&type=script&lang=js"
import style0 from "./Courses.vue?vue&type=style&index=0&id=52b0b5ba&prod&scoped=true&lang=css"
import style1 from "./Courses.vue?vue&type=style&index=1&id=52b0b5ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b0b5ba",
  null
  
)

export default component.exports